import React, { type ReactNode } from 'react';
import { Modal, type ModalProps } from 'antd';
import classNames from 'classnames';
import CloseIcon from '~/public/assets/images/svg/pop-up-close-icon.svg';

export interface PopUpModalProps extends ModalProps {
  children: ReactNode;
  open?: boolean;
  title?: string;
  onCancel: () => void;
  className?: string;
  width?: number;
  hideCloseIcon?: boolean;
}
export function PopUpModal({
  open,
  children,
  title = '',
  onCancel,
  className = '',
  width = 300,
  hideCloseIcon,
  ...rest
}: PopUpModalProps) {
  const closeIcon = hideCloseIcon ? null : <CloseIcon />;
  return (
    <div>
      <Modal
        open={open}
        footer={null}
        title={title}
        className={`bg-white-default custom-modal-close ${className}`}
        onCancel={onCancel}
        centered={true}
        width={width}
        closeIcon={closeIcon}
        {...rest}
      >
        {children}
      </Modal>
    </div>
  );
}

interface IHeaderProps extends Omit<PopUpModalProps, 'onCancel'> {}
function Header({ children }: IHeaderProps) {
  return (
    <div className="m-auto mb-1 block text-center text-lg font-semibold text-black-default">
      {children}
    </div>
  );
}

interface IBodyProps extends Omit<PopUpModalProps, 'onCancel'> {}

function Body({ children, className }: IBodyProps) {
  return (
    <div
      className={classNames(
        'align-center m-auto flex w-full flex-col items-center text-justify text-xs !leading-5',
        className
      )}
    >
      {children}
    </div>
  );
}
interface IImageProps extends Omit<PopUpModalProps, 'onCancel'> {}

function Image({ children }: IImageProps) {
  return (
    <div className="m-auto mt-[-20px] flex pr-[52px] text-center">
      {children}
    </div>
  );
}

interface IFooterProps extends Omit<PopUpModalProps, 'onCancel'> {}
function Footer({ children }: IFooterProps) {
  return (
    <div className="m-auto flex h-[72px] w-full items-center justify-center gap-4 overflow-hidden text-center">
      {children}
    </div>
  );
}

PopUpModal.Header = Header;
PopUpModal.Body = Body;
PopUpModal.Image = Image;
PopUpModal.Footer = Footer;
